import React from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
//@ts-ignore cortex
import { useQueryString } from "@cortexglobal/cortex-utilities";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    PageTitle,
    Row,
    Panel,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";
import CalendarEventForm, {
    CalendarEvent,
} from "../../forms/CalendarEventForm";

export const CalendarEventCreate = ({ path }) => {
    const history = useHistory();
    //parent_id will be set if it's in the URL otherwise it's null which is what we want
    const parent_id = useQueryString().get("parent_id");

    const item: CalendarEvent = {
        title: "",
        start_date: new Date(),
        end_date: new Date(),
        description: "",
        notify_users: false,
        notify_before: "",
        // all_day: item.all_day ? item.all_day : false,
        notify_before_frequency: "day",
        event_category_uuid: "",
    };

    const submitForm = (values) => {
        return axios
            .post(`/api/v1/admin/calendar-event`, values)
            .then(({ data }) => {
                if (parent_id !== null) {
                    history.goBack();
                }
                //As creation was successful move them on to the appropriate listing page
                history.push(`${path}`);
            });
    };
    return (
        <div>
            <PageTitle title={<>{trans("New Calendar Event")}</>}>
                <IconTextButton
                    as={Link}
                    to={path}
                    rotation={180}
                    showCircle={false}
                    expanded={false}
                >
                    {trans("Back to listing")}
                </IconTextButton>
            </PageTitle>

            <Row>
                <Panel>
                    <CalendarEventForm item={item} submitForm={submitForm} />
                </Panel>
            </Row>
        </div>
    );
};

export default CalendarEventCreate;
